import { SiteCategory } from './models/site-category.model';
import { cloneDeep, get } from 'lodash';
import { siteNavigation } from './data/site-navigation';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';

export function getAllCategories(): SiteCategory[] {
  return [...siteNavigation.main, ...siteNavigation.categories, ...siteNavigation.specialties];
}

export function getGroupedCategories(language?: string) {
  return {
    all: translateCategories(siteNavigation.main, language),
    anatomy: translateCategories(siteNavigation.categories, language),
    specialties: translateCategories(siteNavigation.specialties, language),
  };
}

export function translateCategories(categories: SiteCategory[], lang?: string) {
  return categories.map((value) => {
    const category: SiteCategory = {
      id: value.id,
      title: value.title,
      type: value.type,
    };

    if (lang) {
      category.title = get(value, `translations.${lang}.title`, category.title);
    }

    return category;
  });
}

export function getCategory(categoryId: string, language?: string) {
  if (categoryId == null) {
    return null;
  }

  const category = cloneDeep(getAllCategories().find((value) => value.id === categoryId));

  if (category == null) {
    return null;
  }

  if (language) {
    category.title = get(category, `translations.${language}.title`, category.title);
  }

  return category;
}

export function getBookmarkSpecialty(bookmark: BookmarkModel) {
  return siteNavigation.specialties.find((specialty) => {
    return bookmark.tags.some((tag) => tag === specialty.id);
  });
}

export function getBookmarkCategory(bookmark: BookmarkModel) {
  return siteNavigation.categories.find((cateogry) => {
    return bookmark.tags.some((tag) => tag === cateogry.id);
  });
}
